import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { POLDocumentService } from '../../services/document.service';
import { IUserAgreement } from '../../models/state.model';
import { POLAuthService } from '../../services/auth.service';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
  constructor(
    public fb: FormBuilder,
    private documentsService: POLDocumentService,
    private auth: POLAuthService,
    private storageService: StorageService,
    private router: Router,
  ) { }
  @Input() pdfSrc;
  @Input() userAgreement: IUserAgreement;
  formGroup: FormGroup;
  isLoading = false;

  ngOnInit() {
    this.formGroup = this.fb.group(
      {
        name: ['', Validators.required],
        reEnteredName: ['', Validators.required]
      },
      { validators: this.validateName.bind(this) }
    );
    this.pdfSrc = this.getPDFSrc(this.userAgreement);
  }

  validateName(control: AbstractControl): ValidationErrors | null {
    const name = control.get('name')?.value;
    const reEnteredName = control.get('reEnteredName')?.value;
    return name === reEnteredName ? null : { nameMismatchError: true };
  }

  navigateToHome() {
    this.auth.saveUseAgreementDate(this.userAgreement?.documentUrl).subscribe((res) => {
      if (res) {
        const existingUserProfile = JSON.parse(this.storageService.getItem('user-profile'));
        existingUserProfile.useAgreement.signatureRequired = false;
        this.storageService.setItem('user-profile', JSON.stringify(existingUserProfile));
        this.auth.hasUserAgreementData$.next({ hasUserAgreementData: true, useAgreementVaule: false });
      }
    });
  }

  signOut(): void {
    this.auth.signOutRedirect({ signOut: true });
  }

  getPDFSrc(userAgreement: IUserAgreement, onError = () => { }) {
    this.isLoading = true;
    this.documentsService.getBlobContentForDocuments(userAgreement?.documentUrl, '', true).subscribe(
      (blob) => {
        this.isLoading = false;
        if (blob.isMSIE) {
          return (this.pdfSrc = blob.documentBlob);
        } else {
          return (this.pdfSrc = blob.documentUrl);
        }
      },
      (err) => {
        this.isLoading = false;
        onError();
      }
    );
  }

  openDocumentPDF(userAgreement: IUserAgreement, onError = () => { }): void {
    let win: Window;
    const nav = window?.navigator as any;
    if (!nav.msSaveOrOpenBlob) {
      win = window.open();
      win.document.write(
        "<p style=\"font: 400 16px 'Gotham SSm A', 'Gotham SSm B', Arial, sans-serif;\">Retrieving your document...<p>"
      );
    }
    this.documentsService.getBlobContentForDocuments(userAgreement?.documentUrl, '', true).subscribe(
      (blob) => {
        if (blob.isMSIE) {
          nav.msSaveOrOpenBlob(blob.documentBlob, `${blob.fileName}.pdf`);
        } else {
          win.location.href = blob.documentUrl;
        }
      },
      (err) => {
        if (win) {
          win.close();
        }
        onError();
      }
    );
  }
}
